/**
 * Hook to track page views in Google Analytics 4
 * Automatically tracks page views when route changes
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

/**
 * Hook that tracks page views in GA4 when the route changes
 *
 * Usage: Add <PageTracker /> to your App component
 */
export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    // Reset scroll tracking when route changes
    if (window.scrollDepthTracked) {
      window.scrollDepthTracked = {};
    }
    // Track page view when route changes
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);
}

/**
 * Component version - can be added to App.tsx
 */
export function PageTracker(): null {
  usePageTracking();
  return null;
}
